console.log('Base script loaded.');